<script setup lang="ts">
import Card from '~/components/card/Card.vue'
import { FAQ_LIST } from '~/constants/faq.constants'
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { META } from '~/environment-variables/meta.const'
import BcExpand from '~/ui/Expand/BcExpand.vue'
import { getBreadCrumb } from '~/utils/breadCrumbList'

useSeoMeta({
  title: 'FAQ',
  description: 'Find answers to frequently asked questions about MapleStory Universe Explorer',
  get ogDescription () {
    return this.description
  },
  get twitterDescription () {
    return this.description
  }
})

useHead(getBreadCrumb())
</script>

<template>
  <div class="flex flex-col gap-y-8 max-w-[896px] mx-auto">
    <div class="flex items-center justify-between rounded-lg p-8 bg-gradient-to-l from-primary/[16%] to-point-color/40">
      <div class="flex flex-col gap-y-3">
        <span class="align-text-top text-2xl/[1.5rem] font-bold text-primary">FAQ</span>
        <span class="text-base/[0.75rem] text-primary/40">Last updated: May 23, 2025</span>
      </div>
      <img
          :src="`${IMAGE_BASE_URL}/logo/logo_mainnet.png`"
          alt=""
          width="200"
        >
    </div>
    <div class="flex flex-col gap-y-4 font-bold">
      <Card v-for="(faq, index) in FAQ_LIST" :key="index" class="hover:!bg-primary/10 transition-opacity duration-300 ease-[ease]">
        <BcExpand :expand="!index">
          <template #title>
            <span class="text-primary">{{ faq.title }}</span>
          </template>
          <template #body>
            <div class="text-primary/40 px-8 pb-6 pt-4">{{ faq.description }}</div>
          </template>
        </BcExpand>
      </Card>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
